import { toast } from 'react-toastify';

const toastOptions = {
	theme: 'dark',
	pauseOnHover: true,
	position: 'bottom-center',
	draggable: true,
};

export const notify = {
	success: (message) => toast.success(message, toastOptions),
	error: (message) => toast.error(message, toastOptions),
};

export const copyToClipboard = (text, label) => {
	navigator.clipboard
		.writeText(text)
		.then(() => notify.success(`${label} copied to clipboard!`))
		.catch((err) => {
			console.error('Failed to copy text: ', err);
		});
};

export const notYetAvailable = () =>
	notify.error("The link you're trying to copy has not been created yet. Please check back later.");
